export default {"src":"/hedera/_next/static/media/failure.1237a8ee.svg","height":64,"width":64};